<template>
  <div class="box animated fadeIn">
    <div class="outline">
      <div class="rightCon">
        <p class="subtitle" v-html="Container.subtitle"></p>
        <div class="" v-if="LogoUrl.length > 0">
          <img :src="LogoUrl" style="height: 60px" ></img>
        </div>
        <div class="HeaderTitle">
          <div v-html="Container.title"></div>
        </div>
        <div v-for="item in Container.list">
          <p class="title">{{ item.title }}</p>
          <p class="text" v-html="item.body"></p>
        </div>
        <p class="title">乳癌患者分享</p>
        <div
          class="switchbtn2 animated fadeInRight delay-1s"
          v-on:click="ShareOne"
        >
          <Icon size="30" type="ios-arrow-back" />
          Jennifer Yarnell
        </div>
        <div
          class="switchbtn2 animated fadeInRight delay-1s"
          v-on:click="ShareTwo"
        >
          <Icon size="30" type="ios-arrow-back" />
          Judy Schwartz Haley
        </div>
      </div>
      <div class="leftCon">
        <div v-if="Type" class="img" :style="Cover"></div>
        <div v-else class="videos">
          <Media
            :kind="'video'"
            :controls="false"
            :src="videoSrc"
            :autoplay="true"
            :style="{ width: '100%', height: '100%' }"
            :loop="true"
            :ref="'Player'"
          >
          </Media>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Media from "@dongido/vue-viaudio";
export default {
  name: "HelloWorld",
  components: { Media },
  props: {
    LogoUrl:String,
    Type: Boolean,
    ImgUrl: String,
    Container: Object
  },
  data() {
    return {
      Cover: {
        backgroundImage: "url(" + require("../assets/" + this.ImgUrl) + ")"
      },
      videoSrc: require("../../static/A02.mp4")
    };
  },
  mounted() {},

  methods: {
    goBack() {
      this.$router.push("/Home");
    },
    PlayEvent() {
      this.$refs.Player.play();
    },
    PauseEvent() {
      this.$refs.Player.pause();
    },
    ShareOne() {
      this.videoSrc = require("../../static/A02.mp4");
    },
    ShareTwo() {
      this.videoSrc = require("../../static/A03.mp4");
    },
    getVideoSrc() {
      return this.Container.videosrc
        ? require("../../static/" + this.Container.videosrc)
        : "";
    }
  }
};
</script>

<style scoped lang="scss">
.subtitle {
  font-size: 1.5rem;
}
.HeaderTitle {
  line-height: 3rem;
  display: flex;
  justify-content: space-between;
  font-size: 2rem;
  border-bottom: 1px solid #fff;
  margin-bottom: 30px;
  padding-bottom: 20px;
}
.dvline {
  height: 1px;
  background-color: aliceblue;
  margin: 20px;
}
.title {
  font-size: 1.6rem;
}
.text {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  line-height: 2.6rem;
  font-weight: 400;
  text-align: justify;
}

.img {
  width: 100%;
  height: 100%;
  /*position: relative;*/
  background-color: #999999;
  /*background-size: 100%;*/
}

.leftCon {
  width: 63%;
  height: 100%;
}

.rightCon {
  color: #fff;
  text-align: left;
  padding: 60px;
  float: right;
  width: 37%;
  height: 100%;
  background-color: #555555;
}

.outline {
  /*background-color: blueviolet;*/
  height: 100%;
}

.box {
  /*position: absolute;*/
  /*background-color: black;*/
  padding: 120px 60px 50px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: 100%;
}

.videos {
  width: 100%;
  height: 100%;
  background-color: black;
}
.switchbtn2 {
  margin-top: 30px;
  text-align: center;
  border-radius: 30px;
  border: 1px solid #fff;
  line-height: 50px;
  font-size: 1.5rem;
  color: #fff;
  width: fit-content;
  height: 50px;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
